import React from 'react';
import { heroImage, stats } from '../mock';

const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-bg">
        <img src={heroImage} alt="Premium araç iç mekan" />
      </div>
      <div className="hero-content">
        <div className="hero-eyebrow">Döşemede Usta Eller</div>
        <h1 className="hero-title">
          Aracınız. <br />
          <span className="word-accent">Yeniden.</span> <br />
          <span className="word-accent">Parlasın.</span>
        </h1>
        <p className="hero-subtitle">
          Koltuk döşeme, tavan yenileme, direksiyon kaplama ve daha fazlası. Aracınızın iç mekanını uzman ellerde hayata döndürüyoruz.
        </p>
        <div className="hero-buttons">
          <a href="#iletisim" className="btn-primary" onClick={(e) => { e.preventDefault(); scrollTo('iletisim'); }}>
            Randevu Al
          </a>
          <a href="#oncesi-sonrasi" className="btn-secondary" onClick={(e) => { e.preventDefault(); scrollTo('oncesi-sonrasi'); }}>
            Çalışmalarımız →
          </a>
        </div>
        <div className="hero-stats">
          {stats.map((s, i) => (
            <div key={i}>
              <div className={`hero-stat-value ${i === 1 ? 'accent' : ''}`}>{s.value}</div>
              <div className="hero-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="scroll-indicator">Scroll</div>
    </section>
  );
};

export default Hero;
